"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var stream_1 = require("stream");

var ActorRdfMetadata_1 = require("./ActorRdfMetadata");
/**
 * An abstract implementation of {@link ActorRdfMetadata} that
 * only requires the quad test {@link ActorRdfMetadata#isMetadata} method to be overridden.
 */


var ActorRdfMetadataQuadPredicate =
/*#__PURE__*/
function (_ActorRdfMetadata_1$A) {
  _inherits(ActorRdfMetadataQuadPredicate, _ActorRdfMetadata_1$A);

  function ActorRdfMetadataQuadPredicate(args) {
    _classCallCheck(this, ActorRdfMetadataQuadPredicate);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorRdfMetadataQuadPredicate).call(this, args));
  }

  _createClass(ActorRdfMetadataQuadPredicate, [{
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        var _this = this;

        var data, metadata, attachListeners;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = new stream_1.Readable({
                  objectMode: true
                });
                metadata = new stream_1.Readable({
                  objectMode: true
                }); // Delay attachment of listeners until the data or metadata stream is being read.

                attachListeners = function attachListeners() {
                  // Attach listeners only once
                  data._read = metadata._read = function () {
                    return;
                  }; // Forward errors


                  action.quads.on('error', function (error) {
                    data.emit('error', error);
                    metadata.emit('error', error);
                  });
                  var context = {};
                  action.quads.on('data', function (quad) {
                    if (_this.isMetadata(quad, action.url, context)) {
                      metadata.push(quad);
                    } else {
                      data.push(quad);
                    }
                  });
                  action.quads.on('end', function () {
                    data.push(null);
                    metadata.push(null);
                  });
                };

                data._read = metadata._read = function () {
                  attachListeners();
                };

                return _context.abrupt("return", {
                  data: data,
                  metadata: metadata
                });

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function run(_x) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorRdfMetadataQuadPredicate;
}(ActorRdfMetadata_1.ActorRdfMetadata);

exports.ActorRdfMetadataQuadPredicate = ActorRdfMetadataQuadPredicate;